import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ZipCodeResponseDto } from "../dto/response/zipcode-response-dto.interface";

@Injectable({
  providedIn: "root"})
export class ZipCodeService {
  constructor(private _httpClient: HttpClient) {}

  getZipCode(zipcode: string): Observable<ZipCodeResponseDto> {
    return this._httpClient.get<ZipCodeResponseDto>(
      `${environment.viacep}/${zipcode}/json/`
    );
  }
}
